import React, { useState } from 'react'
import { useRichTextEditorContext, MenuButton } from 'mui-tiptap'
import {
  Menu,
  MenuItem,
  ListItemText,
} from '@mui/material'
import SmartButtonIcon from '@mui/icons-material/SmartButton'
import type { ButtonItem } from '@/modules/base/components/inputs/html-input/extensions/mjml-button/types'
import lang from '@/lang'

interface MjmlButtonMenuButtonProps {
  tooltipTitle?: string
  buttons?: ButtonItem[]
  disabled?: boolean
}

export const MjmlButtonMenuButton: React.FC<MjmlButtonMenuButtonProps> = ({
  tooltipTitle = lang.htmlInput.tooltipLabels.mjmlButton,
  disabled = false,
  buttons = [],
}) => {
  const editor = useRichTextEditorContext()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleInsertButton = (button: ButtonItem) => {
    if (editor) {
      editor.commands.insertMjmlButton({
        text: button.label,
        href: button.href || '#',
        mjClass: button.mjClass || '',
        cssClass: button.cssClass || '',
      })
    }
    handleClose()
  }

  const isDisabled = disabled || !editor

  return (
    <>
      <MenuButton
        value="mjmlButton"
        tooltipLabel={tooltipTitle}
        onClick={handleClick}
        disabled={isDisabled}
        selected={false}
      >
        <SmartButtonIcon fontSize="small" />
      </MenuButton>

      <Menu
        id="mjml-button-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'mjml-button-menu-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {buttons.map((option, index) => (
          <MenuItem
            key={index}

            onClick={() => handleInsertButton(option)}
            dense
          >
            <ListItemText
              primary={option.label}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
